import {creates, hoistCmp} from '@xh/hoist/core';
import {QuoteWidgetModel} from './QuoteWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {grid} from '@xh/hoist/cmp/grid';
import './QuoteWidget.scss';
import {popover} from '@xh/hoist/kit/blueprint';
import {Icon} from '@xh/hoist/icon';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {securityPicker} from '../../../../cmp/securityPicker/SecurityPicker';
import {div, filler} from '@xh/hoist/cmp/layout';
import {button} from '@xh/hoist/desktop/cmp/button';
import {numberInput} from '@xh/hoist/desktop/cmp/input';
import {widgetToolbarLabel} from '../../../../cmp/widget/WidgetToolbarLabel';

export const quoteWidget = hoistCmp.factory({
    model: creates(QuoteWidgetModel),
    render({model}) {
        return panel({
            className: 'quote-widget',
            items: [config(), grid({model: model.quotesGridModel})]
        });
    }
});

const config = hoistCmp.factory<QuoteWidgetModel>(({model}) =>
    popover({
        item: div({style: {width: 0, height: 0}}),
        isOpen: model.isConfigOpen,
        onClose: () => model.closeConfig(),
        onOpening: () => model.populateConfig(),
        content: configPanel()
    })
);

const configPanel = hoistCmp.factory<QuoteWidgetModel>(({model}) => {
    return panel({
        compactHeader: true,
        title: 'Configure Quotes',
        icon: Icon.edit(),
        style: {width: 400, height: 300, border: 'var(--xh-border-solid'},
        tbar: tbar(),
        item: grid({model: model.configGridModel, agOptions: model.agOptions}),
        bbar: bbar(),
        mask: model.apiTask
    });
});

const tbar = hoistCmp.factory<QuoteWidgetModel>(({model}) =>
    toolbar(
        securityPicker({
            onSecuritySelected: security => model.addSecurity(security),
            autofocus: true,
            showSearchIcon: true,
            placeholder: 'Search tickers...',
            width: 340
        })
    )
);

const bbar = hoistCmp.factory<QuoteWidgetModel>(({model}) =>
    toolbar({
        compact: true,
        items: [
            widgetToolbarLabel('precision'),
            numberInput({
                bind: 'precision',
                width: 40
            }),
            filler(),
            button({
                text: 'Cancel',
                onClick: () => model.closeConfig()
            }),
            button({
                icon: Icon.check(),
                text: 'Save',
                intent: 'success',
                onClick: () => model.applyConfig()
            })
        ]
    })
);
